module.exports = __webpack_public_path__ + "static/media/rio_skyline.ce9dc56b.png";